<script lang="ts">
	import { shortId } from '../utils/html';
	import FormError from './FormError.svelte';
	import Hint from './Hint.svelte';
	import MediaBlock from './MediaBlock.svelte';
	import Icon from './Icon.svelte';
	import { isRequired } from '../utils/forms';
	import type { HTMLInputValidationProps } from '../types/props';
	import { t } from 'svelte-i18n';

	export let id: string | null = null;
	export let tooltip = null;
	export let hint: string | null = null;
	export let validation: HTMLInputValidationProps = { rules: [] };
	export let label: string | null = null;
	export let labelIcon: string | null = null;
	export let classNames = null;
	export let required = false;
	export let pristine = true;
	export let dirty = false;
	export let value = null;

	let autoId = `formControl_${shortId()}`;

	if (required) {
		validation = validation ?? { rules: [] };
		validation = {
			rules: [
				...(validation.rules || []),
				{ label: $t('forms.validators.required'), check: isRequired }
			]
		};
	}

	$: if (validation && validation.rules.length) {
		let isValid = true;
		validation.rules.forEach((rule, index) => {
			let isRuleValid = rule.check(value);
			validation.rules[index] = {
				...rule,
				valid: isRuleValid
			};
			isValid = isValid && isRuleValid;
		});
		validation.valid = isValid;
	}
</script>

<div class={classNames}>
	{#if label || hint}
		<div class="inline-flex space-x-1 items-center">
			{#if labelIcon}
				<Icon name={labelIcon} />
			{/if}
			{#if label}
				<label for={id || autoId}>
					{label}
					{required ? '*' : ''}
				</label>
			{/if}
			<div class="flex items-center">
				{#if hint}
					<Hint>{hint}</Hint>
				{/if}
			</div>
		</div>
	{/if}
	<MediaBlock classNames="space-x-3" vAlign={validation.valid ? 'center' : 'start'}>
		<div class="relative">
			<slot {autoId} {pristine} {dirty} {tooltip} {validation} {value} />
			{#if dirty && validation.rules.length}
				<div class="icon">
					<Icon
						name={validation.valid ? 'valid' : 'warning'}
						classNames={validation.valid ? 'text-success' : 'text-danger'}
					/>
				</div>
			{/if}
		</div>
		{#if dirty && validation.rules.length && !validation.valid}
			<FormError {validation} />
		{/if}
		<div class="actions" slot="end">
			<slot name="actions" />
		</div>
	</MediaBlock>
</div>

<style lang="postcss">
	.icon {
		@apply w-4 h-4 absolute top-2/4 right-px transform-gpu -translate-y-2/4 -translate-x-2/4;
	}
</style>
